export const getCurrentURL = () => {
    const url = new URL(window.location.href);
    url.search = '';

    const { href } = url;

    if (href.endsWith('/')) {
        return href.slice(0, -1);
    }
    return href;
};
